export default __webpack_public_path__ + "static/media/NTORQ 125 RT FI_1.f60fd298.webp";